var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-switch-wrapper",attrs:{"data-deliver-part":"deliver-code"}},[_c('ot-switch',{staticClass:"ot-switch-wrapper__field"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }